import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './RecentLocations.scss'

class RecentLocations extends PureComponent {
  render () {
    return (
      <div className='sc-panel recentlocations'>
        <h2 className='h3 recentlocations-title' tabIndex='0'>You recently searched for...</h2>
        <ol className='recentlocations-list list-unstyled'>
          {
            this.props.locations.map((location, index) =>
              <li key={index} className='recentlocations-name' data-el={'recent-location-' + index}>
                <button className='recentlocations-btn btn-js link-btn' onClick={event => this.props.showStoresForLocation(event, location, false)} tabIndex='0'>
                  {location}
                </button>
              </li>
            )
          }
        </ol>
      </div>
    )
  }
}

RecentLocations.defaultProps = {
  locations: []
}

RecentLocations.propTypes = {
  locations: PropTypes.array,
  showStoresForLocation: PropTypes.func
}

export default RecentLocations



// WEBPACK FOOTER //
// ./src/components/RecentLocations/RecentLocations.jsx